import { createTrendsFeed } from './stores.js';
import { derived } from 'svelte/store';

import {
  renderSvelteComponent,
  findElementByIdInShadowDom,
} from './utils/render.js';

import SenateTrends from './components/SenateTrends.svelte';

async function main() {
  const trendsFeed = await createTrendsFeed();

  const usSenateTrends = derived(trendsFeed, ($feed) => {
    const senate = $feed.data?.attributes?.senate;

    if (!senate || typeof senate.total !== 'number') {
      throw new Error(
        'Trends response does not contain Senate data with a numeric total.'
      );
    }

    return senate;
  });

  const element = findElementByIdInShadowDom('trends-us-senate-viz');

  if (element) {
    renderSvelteComponent(SenateTrends, element, {
      feed: usSenateTrends,
    });
  }
}

main().catch(console.error);
